import { render, staticRenderFns } from "./GetOTP.vue?vue&type=template&id=72ded72f&"
import script from "./GetOTP.vue?vue&type=script&lang=js&"
export * from "./GetOTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports